import React, {useContext, useEffect, useRef, useState} from 'react';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import {observer} from 'mobx-react-lite';
import {Context} from '../../index';
import {
    CONTACTS_ROUTE,
    EDIT_NEWS_ROUTE,
    EXAMPLES_ROUTE,
    LAYOUTS_AND_DESIGN_ROUTE,
    LOGIN_ROUTE,
    MAIN_ROUTE,
    SERVICES_ROUTE,
} from '../../utils/const';
import {CONTACTS} from '../../data/siteData';
import logo from '../../images/logo.png';
import styles from './NavigationPanel.module.css';

const navLinks = [
    {to: SERVICES_ROUTE, label: 'Услуги'},
    {to: EXAMPLES_ROUTE, label: 'Примеры работ'},
    {to: LAYOUTS_AND_DESIGN_ROUTE, label: 'Макеты и дизайн'},
    {to: CONTACTS_ROUTE, label: 'Контакты'},
];

const NavigationPanel = observer(() => {
    const {user, global} = useContext(Context);
    const navigate = useNavigate();
    const location = useLocation();
    const buttonRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const isActiveLink = (to) => location.pathname === to || location.pathname.startsWith(`${to}/`);

    const closeMenu = ({restoreFocus = false} = {}) => {
        setIsOpen(false);
        if (restoreFocus) {
            window.setTimeout(() => buttonRef.current?.focus(), 0);
        }
    };

    useEffect(() => {
        closeMenu();
    }, [location.pathname]);

    useEffect(() => {
        if (!isOpen) return undefined;

        const onKeyDown = (event) => {
            if (event.key === 'Escape') {
                closeMenu({restoreFocus: true});
            }
        };

        document.body.classList.add('menu-open');
        window.addEventListener('keydown', onKeyDown);

        return () => {
            document.body.classList.remove('menu-open');
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [isOpen]);

    if (global.isAdminPage) {
        return (
            <header className={styles.header}>
                <div className={styles.inner}>
                    <Link to={MAIN_ROUTE} className={styles.brand} aria-label="4 Цвета, на главную">
                        <img src={logo} alt="4 Цвета"/>
                    </Link>
                    <nav className={styles.adminNav} aria-label="Администрирование">
                        {user.isAuth ? (
                            <>
                                <Link to={EDIT_NEWS_ROUTE}>Примеры работ</Link>
                                <button type="button" onClick={() => {
                                    user.authOut();
                                    navigate(LOGIN_ROUTE);
                                }}>Выйти</button>
                            </>
                        ) : (
                            <button type="button" onClick={() => navigate(LOGIN_ROUTE)}>Войти</button>
                        )}
                    </nav>
                </div>
            </header>
        );
    }

    return (
        <header className={styles.header}>
            <div className={styles.inner}>
                <Link to={MAIN_ROUTE} className={styles.brand} aria-label="4 Цвета, на главную">
                    <img src={logo} alt="4 Цвета"/>
                </Link>
                <nav id="main-navigation" className={`${styles.nav} ${isOpen ? styles.open : ''}`} aria-label="Основная навигация">
                    {navLinks.map((link) => (
                        <Link
                            key={link.to}
                            to={link.to}
                            className={isActiveLink(link.to) ? styles.active : undefined}
                            aria-current={isActiveLink(link.to) ? 'page' : undefined}
                        >
                            {link.label}
                        </Link>
                    ))}
                    <span className={styles.phone}>{CONTACTS.mobile}</span>
                </nav>
                <button
                    ref={buttonRef}
                    type="button"
                    className={`${styles.menuButton} ${isOpen ? styles.menuButtonOpen : ''}`}
                    aria-label={isOpen ? 'Закрыть меню' : 'Открыть меню'}
                    aria-expanded={isOpen}
                    aria-controls="main-navigation"
                    onClick={() => setIsOpen((value) => !value)}
                >
                    <span className={styles.menuIcon} aria-hidden="true"/>
                </button>
            </div>
        </header>
    );
});

export default NavigationPanel;
